import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import toast from "react-hot-toast";

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "blogger",
    assigned_pages: [],
  });

  const load = async () => {
    const res = await api.get("/admin/users");
    setUsers(res.data);
  };

  const create = async (e) => {
    e.preventDefault();

    try {
      await api.post("/admin/users", form);
      toast.success("Admin user created");
      setForm({
        name: "",
        email: "",
        password: "",
        role: "blogger",
        assigned_pages: [],
      });
      load();
    } catch (err) {
      toast.error(err.cleanMessage);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete user?")) return;

    try {
      await api.delete(`/admin/users/${id}`);
      toast.success("User deleted");
      load();
    } catch (err) {
      toast.error(err.cleanMessage);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <section>
      <h1 className="text-3xl font-black text-[#0b6b1d] mb-6">
        Admin Users
      </h1>

      <form onSubmit={create} className="bg-white rounded-3xl border p-6 grid md:grid-cols-2 gap-4 mb-6">
        <input
          required
          placeholder="Full name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          className="border rounded-2xl px-4 py-3"
        />

        <input
          required
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          className="border rounded-2xl px-4 py-3"
        />

        <input
          required
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          className="border rounded-2xl px-4 py-3"
        />

        <select
          value={form.role}
          onChange={(e) => setForm({ ...form, role: e.target.value })}
          className="border rounded-2xl px-4 py-3"
        >
          <option value="admin">Admin</option>
          <option value="editor">Editor</option>
          <option value="blogger">Blogger</option>
        </select>

        <button className="md:col-span-2 py-3 rounded-2xl bg-[#0b6b1d] text-white font-black">
          Create User
        </button>
      </form>

      <div className="bg-white rounded-3xl border overflow-hidden">
        {users.map((user) => (
          <div key={user.id} className="p-4 border-b flex justify-between">
            <div>
              <p className="font-black">{user.name}</p>
              <p className="text-sm text-slate-500">{user.email}</p>
            </div>

            <div className="text-right">
              <p className="font-bold">{user.role}</p>
              <button onClick={() => remove(user.id)} className="text-red-600 text-sm">
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AdminUsers;